import createCrudVuexModule from "@/store/crud";

export const policy = createCrudVuexModule({
  namespaced: true,
  path: "/library/policy",
});

const taskDefinition = {
  state: { editedTask: undefined, tasks: [] },
  getters: { editedTask: (state) => state.editedTask, tasks: (state) => state.tasks },
  mutations: {
    tasks: (state, value) => (state.tasks = value ?? []),
    editedTask: (state, value) => (state.editedTask = value),

    addTaskItem: (state, { task }) => {
      if (!task._id) {
        task._id = "id" + new Date().getTime(); //id atama
      }

      state.tasks = [...state.tasks, { ...task }];
    },
    updateTaskItem: (state, { task }) => {
      state.tasks = state.tasks.map((t) => {
        if (t._id == task._id) {
          t = task;
        }

        t.blockedByTasks = t.blockedByTasks?.map((x) => {
          if (x._id == task._id) {
            return task;
          }
          return x;
        });

        return t;
      });
    },

    removeTaskItem: (state, { task }) => {
      state.tasks = [...state.tasks.filter((t) => t._id != task._id)];
    },
    reset: (state, value) => {
      state.editedTask = undefined;
      state.tasks = [];
    },
  },
  actions: {},
};

export const workspacePolicy = createCrudVuexModule({
  namespaced: true,
  path: "/workspace/library/policy",

  state: { ...taskDefinition.state },
  getters: { ...taskDefinition.getters },
  mutations: { ...taskDefinition.mutations },
  actions: { ...taskDefinition.actions },
});

export const managementPolicy = createCrudVuexModule({
  namespaced: true,
  path: "/management/library/policy",

  state: { ...taskDefinition.state },
  getters: { ...taskDefinition.getters },
  mutations: { ...taskDefinition.mutations },
  actions: {
    ...taskDefinition.actions,
    async save({ commit, dispatch }, payload) {
      if (payload._id) {
        await dispatch("update", payload);
      } else {
        await dispatch("create", payload);
      }
      commit("reset");
    },
  },
});

export const managementPolicyGroup = createCrudVuexModule({
  namespaced: true,
  path: "/management/library/policy-group",
});

export const workspacePolicyGroup = createCrudVuexModule({
  namespaced: true,
  path: "/workspace/library/policy-group",
});

export const libraryPolicyGroup = createCrudVuexModule({
  namespaced: true,
  path: "/library/policy-group",
});
